import React from 'react';

const Gym: React.FC = () => {
  return (
    <svg viewBox="0 0 65 34" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g stroke="none" strokeWidth="1" fillRule="evenodd">
        <g fillRule="nonzero">
          <path d="M9.88,0.34 L17.25,2.13 L17.25,32.27 L9.88,33.66 L9.88,0.34 Z M55.5,33.66 L48.02,32.55 L48.02,1.57 L55.5,0.34 L55.5,33.66 Z M65,27.48 L58.99,26.38 L58.99,8.06 L65,6.85 L65,27.48 Z M0.78,6.85 L6.79,7.94 L6.79,26.26 L0.78,27.48 L0.78,6.85 Z M19.42,14.23 L45.32,14.23 L45.32,19.76 L19.42,19.76 L19.42,14.23 Z"></path>
        </g>
      </g>
    </svg>
  );
};

export { Gym };
